import { Typography } from '@mui/material';

import type { Sx } from '@/types/helpers';

const PremiumFeatureMessage = ({ sx }: { sx?: Sx }) => (
  <>
    <Typography sx={sx}>This feature isn't included in your plan.</Typography>
    <Typography sx={sx}>Upgrade for advanced functionality.</Typography>
  </>
);

export default PremiumFeatureMessage;
